<h2
    tabindex="0"
    mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="email_move_to_folder"
></h2>
<mat-dialog-content class="email-archive-dialog-content">
    <tt-search
        ttLabel="email_move_to_folder_name"
        [(ttModel)]="$any(get).move_to_folder_name"
        ttMinLength="0"
        [ttSearch]="searchMoveMailFolders"
        (ttOnSelected)="onMoveToFolderSelected($event)"
        (ttOnClear)="onMoveToFolderSelected()"
    ></tt-search>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <tt-button-save ttText="w_email_move_to_folder" ttIcon="far fa-folder-upload" (ttClick)="move()" [ttLoading]="moving" [ttDisabled]="!$any(get).move_to_folder_id"></tt-button-save>
</mat-dialog-actions>
